// SummaryPanel.jsx
import "./SummaryPanel.scss";

import { Alert, Card, ProgressBar } from "react-bootstrap";
import React, { useMemo } from "react";

function safePct(n) {
  const v = Number(n);
  if (!Number.isFinite(v)) return 0;
  return Math.max(0, Math.min(100, Math.round(v)));
}

export default function SummaryPanel({ summary, counts, showAdvanced, confidence }) {
  const totalUF = summary?.totalUF || 0;

  const pct = useMemo(() => {
    return {
      s: safePct(summary?.pctSingles),
      d: safePct(summary?.pctDoubles),
      t: safePct(summary?.pctTriples),
    };
  }, [summary]);

  const readingText = useMemo(() => {
    if (pct.s >= 60) {
      return "Alta proporção de unidades simples pode sugerir afinamento/miniaturização (interpretar com histórico e área controle).";
    }
    if (pct.s >= 45) {
      return "Distribuição com leve predominância de unidades simples (avaliar junto do controle e evolução).";
    }
    return "Distribuição sem predominância forte de unidades simples.";
  }, [pct.s]);

  return (
    <Card className="tricho-card tricho-summary">
      <Card.Body>
        <div className="tricho-summary__head">
          <div className="tricho-panel-title m-0">Resumo</div>

          {showAdvanced && (
            <div className="tricho-summary__chip">
              IA ≥ <strong>{Number(confidence ?? 0).toFixed(2)}</strong>
            </div>
          )}
        </div>

        <div className="tricho-stat-grid tricho-summary__stats">
          <div className="tricho-stat tricho-summary__stat">
            <div className="tricho-stat__label">Total unidades (UF)</div>
            <div className="tricho-stat__value">{totalUF}</div>
          </div>

          <div className="tricho-stat tricho-summary__stat">
            <div className="tricho-stat__label">Total fios (estimado)</div>
            <div className="tricho-stat__value">{summary?.totalFios ?? 0}</div>
          </div>

          <div className="tricho-stat tricho-summary__stat">
            <div className="tricho-stat__label">Densidade (UF/cm²)</div>
            <div className="tricho-stat__value">
              {summary?.densityUF == null ? "—" : summary.densityUF}
            </div>
          </div>

          <div className="tricho-stat tricho-summary__stat">
            <div className="tricho-stat__label">Óstios</div>
            <div className="tricho-stat__value">{counts?.OSTIUM ?? 0}</div>
          </div>
        </div>

        <div className="tricho-summary__dist">
          <div className="tricho-block__label mb-2">Distribuição</div>

          <div className="tricho-summary__bar">
            <div className="tricho-pct-row">
              <span>Simples</span>
              <strong>{pct.s}%</strong>
            </div>
            <ProgressBar now={pct.s} className="tricho-summary__progress" />
          </div>

          <div className="tricho-summary__bar">
            <div className="tricho-pct-row">
              <span>Duplas</span>
              <strong>{pct.d}%</strong>
            </div>
            <ProgressBar now={pct.d} className="tricho-summary__progress" />
          </div>

          <div className="tricho-summary__bar">
            <div className="tricho-pct-row">
              <span>Triplas</span>
              <strong>{pct.t}%</strong>
            </div>
            <ProgressBar now={pct.t} className="tricho-summary__progress" />
          </div>
        </div>

        <Alert
          variant={summary?.severity?.variant || "secondary"}
          className="mt-3 mb-0 tricho-alert tricho-summary__alert"
        >
          <div className="tricho-summary__alertTitle">
            <strong>Leitura do padrão:</strong>{" "}
            <span>{summary?.severity?.label || "—"}</span>
          </div>

          <div className="tricho-summary__alertBody">{readingText}</div>

          {showAdvanced && (
            <div className="tricho-alert__sub">
              Avançado: filtro de IA ativo em ≥ <strong>{Number(confidence ?? 0).toFixed(2)}</strong>.
            </div>
          )}
        </Alert>
      </Card.Body>
    </Card>
  );
}